import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { LOGGED_IN_QUERY_KEY } from './queries';
import { useApplicationStore } from '../stores/applicationStore';

export function useGetLogoutFn(): () => Promise<void> {
	const queryClient = useQueryClient();
	const setUserId = useApplicationStore((s) => s.setUserId);
	const router = useRouter();

	const handleLogout = useCallback(async () => {
		await fetch('/api/user/logout')
			// Ignore any errors, these are handled in the api
			.catch()
			.finally(async () => {
				setUserId('');
				await router.replace('/login', undefined, {
					shallow: true,
				});
				await queryClient.resetQueries({ queryKey: [LOGGED_IN_QUERY_KEY] });
			});
	}, [router, queryClient, setUserId]);

	return handleLogout;
}
